import { gql } from "@/__generated__/gql";

export const ORGANIZATION_LIVE_EVENTS_QUERY = gql(`
  query OrganizationLiveEvents(
    $orgId: ID!,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int,
    $audience: [LiveEventAudienceEnum!],
    $eventType: [LiveEventTypeEnum!],
    $createdBy: [ID!],
    $ordering: [LiveEventOrderingInput!]!,
    $status: [LiveEventStatusEnum!]!,
    $chatChannel: [ID!]
  ) {
    node(id: $orgId) {
      id
      ... on Organization {
        __typename
        liveEvents(
          first: $first
          last: $last
          after: $after
          before: $before
          audience: $audience
          eventType: $eventType
          createdBy: $createdBy
          ordering: $ordering
          status: $status
          chatChannel: $chatChannel
        ) {
          edges {
            node {
              id
              name
              eventType
              audience
              startsAt
              endsAt
              chatChannel {
                id
                name
                displayName
                roomName
              }
              createdBy {
                id
                firstName
                lastName
                uuid
                profilePhoto {
                  id
                  url(size: 24)
                }
              }
              statistics {
                totalMessages
                totalParticipants
                studentsWhoMessaged
                totalChannelOpens
              }
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
            hasPreviousPage
            startCursor
          }
          totalCount
        }
      }
    }
  }
`);
